/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timecode_Conversion_FailedInputs */



/**
* | output |
* | --- |
* | "Timecode conversion failed." |
*
* @param {Timecode_Conversion_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timecode_conversion_failed = /** @type {((inputs?: Timecode_Conversion_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timecode_Conversion_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec de la conversion du timecode.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Timecode-Konvertierung ist fehlgeschlagen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Conversione del timecode non riuscita.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Преобразование временного кода не удалось.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error en la conversión del código de tiempo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("时间码转换失败。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイムコード変換に失敗しました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टाइमकोड रूपांतरण विफल रहा।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A conversão do código de tempo falhou.")
	return /** @type {LocalizedString} */ ("Timecode conversion failed.")
});